import { render, staticRenderFns } from "./EndEventProps.vue?vue&type=template&id=bfcb107c"
import script from "./EndEventProps.vue?vue&type=script&lang=js"
export * from "./EndEventProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports